import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import TeamTable from '../components/TeamTable';
import { API_ENDPOINTS } from '../config/api';

const TeamsPage = () => {
    return (
        <Container maxWidth="xl">
            <Box sx={{ my: 4 }}>
                <Typography variant="h3" component="h1" gutterBottom>
                    Active Teams
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                    Explore team data including total TPE, player counts, and organizational structure.
                </Typography>
                <TeamTable apiUrl={API_ENDPOINTS.ACTIVE_TEAMS} />
            </Box>
        </Container>
    );
};

export default TeamsPage;